import { IconButton, InputAdornment, TextField } from '@mui/material'
import tw from 'twin.macro'
import { CircleCancelMinor, SearchMinor } from '@shopify/polaris-icons'
import { ChangeEvent, useCallback, useContext, useEffect, useRef, useState } from 'react'
import { TeamContext } from '../Team.context'
import _ from 'lodash'
import { TeamMemberStatusSelect } from './TeamMemberStatusSelect'

interface Props {
  isShowStatusSelect: boolean
}

export const TeamTableHeader = ({ isShowStatusSelect }: Props) => {
  const { setSearchQuery, searchQuery } = useContext(TeamContext)

  const searchDebounce = useRef(_.debounce(setSearchQuery, 700))

  const [searchValue, setSearchValue] = useState<string>(searchQuery)

  const handleSearchChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }, [])

  useEffect(() => {
    searchDebounce.current(searchValue)
  }, [searchValue])

  const handleClear = useCallback(() => {
    setSearchValue('')
    setSearchQuery('')
  }, [])

  return (
    <div
      css={tw`flex flex-row items-center gap-4 bg-white px-4 py-3 border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`bg-white flex rounded-lg flex-row overflow-hidden w-[284px]`}>
        <TextField
          placeholder="Search"
          type="text"
          variant="outlined"
          fullWidth
          value={searchValue}
          size="small"
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchMinor width={20} />
              </InputAdornment>
            ),

            endAdornment: searchQuery && (
              <InputAdornment position="end">
                <IconButton css={tw`mr-[-12px] rounded-none`} onClick={handleClear}>
                  <CircleCancelMinor width={20} fill="#B4AFC0" />
                </IconButton>
              </InputAdornment>
            ),
            sx: {
              '&:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
                border: '1px solid var(--Shades-Grey-100, #EDEDED)',
              },
            },
          }}
        />
      </div>
      {isShowStatusSelect && <TeamMemberStatusSelect />}
    </div>
  )
}
